require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./member-abdur-rahman-alindao.json") })
        }
      }, "path---member-abdur-rahman-alindao");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---member-abdur-rahman-alindao!./.cache/json/member-abdur-rahman-alindao.json
// module id = 391
// module chunks = 231608221292675